export default "__VITE_ASSET__2d0d7031__"